import React from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CompanyLogo from './CompanyLogo';

// `onMenuClick` is optional — pass it to show a hamburger button (used by
// DashboardLayout to open the nav drawer on small screens). Pages without a
// side nav (e.g. a bare header) simply omit it and no button renders.
const AppHeader = ({ title, children, onMenuClick }) => (
  <AppBar position="static">
    <Toolbar sx={{ py: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, gap: 2 }}>
        {onMenuClick && (
          <IconButton
            color="inherit"
            edge="start"
            onClick={onMenuClick}
            sx={{ display: { xs: 'inline-flex', md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Box sx={{ bgcolor: '#0b1220', borderRadius: 1.5, px: 1.25, py: 0.75, display: 'flex' }}>
          <CompanyLogo height={34} />
        </Box>
        <Typography variant="h6" component="div" sx={{ display: { xs: 'none', sm: 'block' }, fontWeight: 600 }}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {children}
      </Box>
    </Toolbar>
  </AppBar>
);

export default AppHeader;
